// 小程序 webview 环境探测 + 拍照委托（暂存表 + 轮询）
// 适用于 H5 被微信小程序 <web-view> 包裹时，委托宿主小程序原生拍照。
import { post } from '@/http/http';

// 是否处于小程序 webview 环境
export const isInMiniProgram = () =>
    window.__wxjs_environment === 'miniprogram' ||
    /miniProgram/i.test(navigator.userAgent);

// 动态加载 jweixin（仅在小程序环境才加载）
export const loadWxJssdk = () => new Promise((resolve, reject) => {
    if (window.wx) return resolve(window.wx);
    const s = document.createElement('script');
    s.src = 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js';
    s.onload = () => resolve(window.wx);
    s.onerror = () => reject(new Error('jweixin 加载失败'));
    document.head.appendChild(s);
});

/**
 * 委托小程序打开原生地图导航（wx.openLocation）
 * 仅在 webview 内的 H5 无法直接拉起系统地图时使用。单向，无需回传数据。
 * 需小程序提供原生页 /pages/navigation/navigation（见开发方案 2.7）
 * @param {Object} { lng, lat, name, address }
 */
export const openLocationInMiniProgram = async ({ lng, lat, name = '', address = '' } = {}) => {
    const wx = await loadWxJssdk();
    const query = `?longitude=${encodeURIComponent(lng)}`
        + `&latitude=${encodeURIComponent(lat)}`
        + `&name=${encodeURIComponent(name || '')}`
        + `&address=${encodeURIComponent(address || '')}`;
    wx.miniProgram.navigateTo({ url: '/pages/navigation/navigation' + query });
};

/**
 * 一键导航（自动判断环境）
 * 小程序 webview 内 → 委托原生 wx.openLocation
 * 普通浏览器 / 微信内置浏览器 → 高德 web 导航
 * @param {Object} { lng, lat, name?, address? }
 * @returns {Promise<boolean>} 是否走了小程序原生导航
 */
export const navigateToLocation = async ({ lng, lat, name = '', address = '' } = {}) => {
    if (lng == null || lat == null) {
        throw new Error('无坐标信息');
    }
    if (isInMiniProgram()) {
        await openLocationInMiniProgram({ lng, lat, name, address });
        return true;
    }
    const url = `https://uri.amap.com/navigation?to=${lng},${lat}&mode=car&policy=1&src=hx-monitor&coordinate=gaode&callnative=0`;
    window.location.href = url;
    return false;
};
